import data, { type Emoji } from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { ChakraV3, FloatingPopover } from '@piccolohealth/ui';
import React from 'react';
import { MdAddReaction } from 'react-icons/md';

interface Props extends Omit<ChakraV3.ButtonProps, 'onSelect'> {
  onSelect: (emoji: Emoji) => void;
}

export const EmojiPickerButton = (props: Props) => {
  const { onSelect, ...rest } = props;

  return (
    <FloatingPopover
      placement='bottom'
      render={() => (
        <ChakraV3.Stack shadow='2xl' rounded='lg' overflow='hidden'>
          <Picker
            data={data}
            onEmojiSelect={onSelect}
            previewPosition='none'
            theme='light'
            autoFocus
          />
        </ChakraV3.Stack>
      )}
    >
      <ChakraV3.Button size='sm' p='2' rounded='full' bg='white' color='secondary' {...rest}>
        <MdAddReaction />
      </ChakraV3.Button>
    </FloatingPopover>
  );
};
